
import axios from 'axios'

const prefix = '@RAH'
window.RAH_prefix = prefix

const DEFAULT_HEADERS = {
  'Accept': 'application/json',
}


function defaultValues(endpoints){
  let result = {}
  const defaultRequest = {
    status: 'pending',
    error: null,
    fetching: false,
  }
  endpoints.map(endpoint => {
    result = {
      ...result,
      [endpoint.id]: null,
      requests : {
        [endpoint.id] : {
          [endpoint.method] : defaultRequest,
        }
      }
    }
  })
  return result
}

function init(config, store){
  store.dispatch({
    type: `${prefix}_INIT`,
    payload: defaultValues(config.endpoints)
  })
}

function sendAPIRequest(requestConfig){
  axios(requestConfig)
}

export const reduxAPIHandler = config => store => {
  init(config, store)
  return next => action => {
    const endpoint = config.endpoints.filter(ep => ep.action === action.type)[0]

    if(endpoint){
      const url = `${config.host}/${endpoint.url}`
      const method = endpoint.method
      const ep_headers = {...config.headers, ...endpoint.headers}
      const headers = Object.keys(ep_headers).length > 0 ? ep_headers : DEFAULT_HEADERS

      sendAPIRequest({
        url,
        method: 'GET',
        headers,
      })

    }

    next(action)
  }
}



// WEBPACK FOOTER //
// ./src/redux/redux-api-handler/index.js